export default "__VITE_ASSET__0JHawXGK__"